module.exports = {
  common: {
    welcome: '欢迎使用',
    lang: '语言',
    currentLang: '中文',
    clear: '清空',
    noMore: '没有更多',
    seeAll: '查看所有',
    see: '查看',
    add: '添加',
    select: '选择',
    confirm: '确认',
    cancel: '取消',
    password: '密码',
    needPasswordTip: '请填写密码',
    selectTip: '请选择',
    fillTip: '请填写',
    submit: '提交',
    default: '默认',
    operationSuccess: '操作成功',
    deleteSuccess: '删除成功',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    welcome: '欢迎使用',
    startUpload: '开始上传',
    uploadSuccess: '上传成功',
    remark: '备注',
    agree: '同意',
  },
  login: {
    registTip: '想成为会员享有折扣商品？',
    contactUs: '联系我们',
    tip4supplier: 'StarPay技术支持',
  },
  product: {
    title: '商品',
    all: '全部',
    name: '商品名称',
    spec: '规格',
    unit: '单位',
    price: '价格',
    addToCart: '加入购物车',
    buyCount: '购买数量',
    selectSpecTip: '请选择规格',
    addedToCartTip: '已经添加到购物车',
    category: '分类',
  },
  shoppingcart: {
    title: '购物车',
    noAddressTip: '选择收货地址',
    productOriginalPrice: '产品原价',
    deposit: '定金',
    agentFreight: '代运费',
    payPrice: '付款金额(定金+代运费)',
    accountBalance: '账户余额',
    payAndOrderButton: '支付并生成订单',
    orderButton: '下单',
    ordering: '订单生成中...',
    noProduct2Buy: '没有可购买的商品',
    selectAddressTip: '请选择收货地址',
    notEnoughMoney: '账户余额不足',
    buyedTip: '购买成功，可以进入订单查看',
    needTransport: '需要运输',
    orderPrice4transportFree: '订单满{0}SOL免代运费',
    termsOfPurchase: '购买条款',
    termsTip: '需要同意购买条款',
    address: '地址',
    logisticsCompany: '物流公司',
  },
  address: {
    add: '新增地址',
    idNumber: '证件号',
    tag: '标签',
  },
  order: {
    title: '订单',
    needDeposit: '需付定金',
    unDeliver: '待发货',
    delivering: '配送中',
    received: '已收货',
    needBalance: '待付尾款',
    all: '全部',
    number: '订单号',
    priceDetail: '价格明细',
    originalPrice: '原价',
    deposit: '定金',
    agentFreight: '代运费',
    seeProducts: '产品查看',
    payOrder: '付款',
    updatePay: '修改付款',
    confirmPayBalance: '确认支付尾款？',
    paySuccess: '支付成功',
    needPay: '当前需付',
    serviceFee: '服务费',
    otherPayMethod: '其它付款方式',
    creditCard: '信用卡',
    receiveAccount: '收款账号',
  },
  user: {
    title: '用户',
    capitalFlow: '资金流水',
    rechargeApply: '充值申请',
    ourContactInfo: '我们的联系方式',
    phone: '电话',
    call: '拨打',
    contact: '联系',
    processing: '处理中...',
    rechargeTip: '充值转款请汇入',
    rechargeBank: '银行：BBVA Continental',
    rechargeBankAccount: '银行账号：0011 0370 0200471779',
    rechargeCCI: '跨行CCI：011 370 000200471779 45',
    rechargeCompanyName: '公司名称：STARPAY DIGITAL S.A.C.',
    rechargeUploadDes: '如已汇款成功，请上传凭证图片，我们将在24小时内完成充值处理。',
    rechargeAmount: '充值金额',
    rechargeAmountTip: '请填写充值金额',
    rechargeUploadTip: '请上传凭证图片',
    rechargeSubmitedTip: '充值申请提交成功，我们将在24小时内完成充值处理。感谢您的支持！',
  },
  account: {
    login: '登录',
    loginTip: '请先登录',
    loginSuccess: '登录成功',
    userName: '用户名',
    needUserNameTip: '请填写用户名',
    changePassword: '更换密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    confirmPasswordWrong: '确认密码错误',
    fillPasswordTip: '请填写密码',
    reLoginTip: '请重新登录',
    logout: '退出登录',
  },
}
